export const parseDateForGql = (date: Date) => {
  let month = (date.getMonth() + 1).toString()
  month = month.length === 1 ? "0" + month : month
  let day = date.getDate().toString()
  day = day.length === 1 ? "0" + day : day

  return `${date.getFullYear()}-${month}-${day}`
}
